//import { css, keyframes  } from '@emotion/core'
//import { variables, mq } from 'cssInJs'

import { css } from '@emotion/core'
import { mq } from 'cssInJs'

export default {
    
    photoGallery : css({
        maxWidth : '960px',
        margin: 'auto',
        marginTop:'2rem',
        marginBottom:'2rem'
    }),
    
    photos : css({
        marginLeft: '-5px',
        marginRight: '-5px',
        '& > div' : {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(183px, 1fr))',
            gap: '10px',
            marginLeft: '0px',
            marginRight: '0px',
        }
        // display: 'flex',
        // flexWrap: 'wrap',
        // marginLeft: '-5px',
        // marginRight: '-5px',
        // '& img' : {
        //     flex: '1 1 150px',
        //     margin: '5px',
        //     paddingTop : '60%',
        //     width : '150px',
        //     border: '1px solid red'
        // }
    }),

    photoContainer: css({
        position: 'relative',
        width: '100%',
        paddingTop: '75%', // 4:3 ratio
        overflow: 'hidden',
        cursor: 'pointer',
  }),

    photo: css({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain', // use 'cover' if needed
    }),
    photoEmpty : css({
        flex: '1 1 150px',
        height : '0px'
    })
}